module.exports = __webpack_public_path__ + "img/id6.785bb068.png";